module.exports = __webpack_public_path__ + "static/media/desktop-and-phone.d4ce0a75.png";